import { render, staticRenderFns } from "./ArtigosHero.vue?vue&type=template&id=1f554928&scoped=true&"
import script from "./ArtigosHero.vue?vue&type=script&lang=js&"
export * from "./ArtigosHero.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosHero.vue?vue&type=style&index=0&id=1f554928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f554928",
  null
  
)

export default component.exports